function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var _require = require('./supply-accounting'),
  balanceSnapshotTip = _require.balanceSnapshotTip;
var PAGE_SIZE = 25;
var REFRESH_INTERVAL_MS = 30000;
var SNAPSHOT_TTL_MS = 5 * 60000;
var MAX_SNAPSHOTS = 3;
var caches = new WeakMap();
function snapshotExpired() {
  var error = new Error('This holder snapshot has expired or the chain changed. Refresh to load the latest holders.');
  error.code = 'SNAPSHOT_EXPIRED';
  return error;
}

// The supply snapshot is authoritative: its rows are unspent, non-Bound
// outputs within the genesis window, including stake that is still locked.
function aggregateHolders(snapshot) {
  var tip = balanceSnapshotTip(snapshot === null || snapshot === void 0 ? void 0 : snapshot.file_name);
  var rows = snapshot === null || snapshot === void 0 ? void 0 : snapshot.rows;
  if (!tip || !Array.isArray(rows)) {
    throw new Error('Balance snapshot unavailable.');
  }
  var holders = new Map();
  var _iterator = _createForOfIteratorHelper(rows),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      var columns = String(row).trim().split(/\s+/);
      if (columns.length !== 6 || !columns[0] || !columns.slice(1).every(function (col) {
        return /^\d+$/.test(col);
      })) {
        throw new Error('Balance snapshot contains an invalid row.');
      }
      var publicKey = columns[0];
      var holder = holders.get(publicKey) || {
        public_key: publicKey,
        balance: 0n,
        utxo_count: 0
      };
      holder.balance += BigInt(columns[4]);
      holder.utxo_count++;
      holders.set(publicKey, holder);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var sorted = _toConsumableArray(holders.values()).sort(function (a, b) {
    if (a.balance !== b.balance) return a.balance > b.balance ? -1 : 1;
    return a.public_key < b.public_key ? -1 : a.public_key > b.public_key ? 1 : 0;
  });
  return _objectSpread(_objectSpread({
    snapshot_id: snapshot.file_name
  }, tip), {}, {
    timestamp: snapshot.file_name.split('-')[0],
    total_utxos: rows.length,
    total_holders: sorted.length,
    rows: sorted.map(function (holder, index) {
      return _objectSpread(_objectSpread({}, holder), {}, {
        rank: index + 1,
        balance: holder.balance.toString()
      });
    })
  });
}
function cacheFor(mod) {
  if (!caches.has(mod)) {
    caches.set(mod, {
      snapshots: new Map(),
      pending: null,
      generation: 0
    });
  }
  return caches.get(mod);
}
function invalidateHolderSnapshots(mod) {
  var cache = caches.get(mod);
  if (cache) {
    cache.generation++;
    cache.snapshots.clear();
  }
}
function getHolderSnapshot(_x, _x2) {
  return _getHolderSnapshot.apply(this, arguments);
}
function _getHolderSnapshot() {
  _getHolderSnapshot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(mod, snapshotId) {
    var cache, now, _iterator2, _step2, _step2$value, id, _entry, entry, latest, generation;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          if (!(typeof (mod === null || mod === void 0 ? void 0 : mod.getSupplyBalanceSnapshot) !== 'function')) {
            _context2.n = 1;
            break;
          }
          throw new Error('Balance snapshot unavailable.');
        case 1:
          cache = cacheFor(mod);
          now = Date.now();
          _iterator2 = _createForOfIteratorHelper(cache.snapshots);
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _step2$value = _slicedToArray(_step2.value, 2), id = _step2$value[0], _entry = _step2$value[1];
              if (now - _entry.created >= SNAPSHOT_TTL_MS) cache.snapshots["delete"](id);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (!snapshotId) {
            _context2.n = 3;
            break;
          }
          entry = cache.snapshots.get(snapshotId);
          if (entry) {
            _context2.n = 2;
            break;
          }
          throw snapshotExpired();
        case 2:
          return _context2.a(2, entry.view);
        case 3:
          latest = _toConsumableArray(cache.snapshots.values()).pop();
          if (!(latest && now - latest.created < REFRESH_INTERVAL_MS)) {
            _context2.n = 4;
            break;
          }
          return _context2.a(2, latest.view);
        case 4:
          if (!cache.pending) {
            _context2.n = 5;
            break;
          }
          return _context2.a(2, cache.pending);
        case 5:
          generation = cache.generation;
          cache.pending = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            var view, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _t = aggregateHolders;
                  _context.n = 1;
                  return mod.getSupplyBalanceSnapshot();
                case 1:
                  view = _t(_context.v);
                  if (!(generation !== cache.generation)) {
                    _context.n = 2;
                    break;
                  }
                  throw snapshotExpired();
                case 2:
                  cache.snapshots["delete"](view.snapshot_id);
                  cache.snapshots.set(view.snapshot_id, {
                    created: Date.now(),
                    view: view
                  });
                  while (cache.snapshots.size > MAX_SNAPSHOTS) {
                    cache.snapshots["delete"](cache.snapshots.keys().next().value);
                  }
                  return _context.a(2, view);
              }
            }, _callee);
          }))();
          _context2.p = 6;
          _context2.n = 7;
          return cache.pending;
        case 7:
          return _context2.a(2, _context2.v);
        case 8:
          _context2.p = 8;
          cache.pending = null;
          return _context2.f(8);
        case 9:
          return _context2.a(2);
      }
    }, _callee2, null, [[6,, 8, 9]]);
  }));
  return _getHolderSnapshot.apply(this, arguments);
}
function getHoldersPage(_x3) {
  return _getHoldersPage.apply(this, arguments);
}
function _getHoldersPage() {
  _getHoldersPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(mod) {
    var _params$page;
    var params,
      rawPage,
      view,
      totalPages,
      page,
      _args3 = arguments;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          params = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
          rawPage = (_params$page = params.page) !== null && _params$page !== void 0 ? _params$page : 1;
          if (!(!['number', 'string'].includes(_typeof(rawPage)) || !/^[1-9]\d*$/.test(String(rawPage)) || !Number.isSafeInteger(Number(rawPage)))) {
            _context3.n = 1;
            break;
          }
          throw new Error('Page must be a positive integer.');
        case 1:
          if (!(params.snapshot_id != null && (typeof params.snapshot_id !== 'string' || params.snapshot_id.length > 150))) {
            _context3.n = 2;
            break;
          }
          throw new Error('Invalid snapshot ID.');
        case 2:
          _context3.n = 3;
          return getHolderSnapshot(mod, params.snapshot_id);
        case 3:
          view = _context3.v;
          totalPages = Math.max(1, Math.ceil(view.total_holders / PAGE_SIZE));
          page = Math.min(Number(rawPage), totalPages);
          return _context3.a(2, _objectSpread(_objectSpread({}, view), {}, {
            page: page,
            page_size: PAGE_SIZE,
            total_pages: totalPages,
            rows: view.rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)
          }));
      }
    }, _callee3);
  }));
  return _getHoldersPage.apply(this, arguments);
}
module.exports = {
  aggregateHolders: aggregateHolders,
  getHoldersPage: getHoldersPage,
  invalidateHolderSnapshots: invalidateHolderSnapshots
};